// extracted by mini-css-extract-plugin
export default {"headingIcon":"EffectiveDateInfo_headingIcon__Nx3r3","heading":"EffectiveDateInfo_heading__QO38a"};